import React from 'react';

export const DotIndicator = ({ status }: { status: 'critical' | 'healthy' | 'alarm' | 'monitor' | 'na' }) => {
  return (
    <div
      className={`w-2 h-2 min-w-2 max-w-2 min-h-2 max-h-2 rounded-full bg-${status === 'na' ? 'notMonitored' : status}`}
    />
  );
};
